/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Replace_ValueInputs */

const en_tables_rule_sets_replace_value = /** @type {(inputs: Tables_Rule_Sets_Replace_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Replace Value`)
};

const de_tables_rule_sets_replace_value = /** @type {(inputs: Tables_Rule_Sets_Replace_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert zu ersetzen`)
};

/**
* | output |
* | --- |
* | "Sets Replace Value" |
*
* @param {Tables_Rule_Sets_Replace_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_replace_value = /** @type {((inputs?: Tables_Rule_Sets_Replace_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Replace_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_replace_value(inputs)
	return de_tables_rule_sets_replace_value(inputs)
});